import { LiveMallSearchCategory, LiveMallSearchType } from '@/types/live-mall-search/types'
import Service, { getCallApiFunction } from '../service'

/*
Type 對應：
0: All
1: Merchant
2: Room
3: Product
4: Member
*/

export type ParamsType = {
  keyword: string
  type: LiveMallSearchCategory
  cursorId?: string
}

class FetchLiveMallSearchDataApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_LIVE_MALL_SEARCH_DATA'
    this.config = {
      url: '/v1/livemall/search',
      method: 'GET',
      params,
    }
  }
}
export function fetchLiveMallSearchData(params: ParamsType): LiveMallSearchType {
  return getCallApiFunction(new FetchLiveMallSearchDataApi(params))
}
